import React from 'react';
import { component_tool } from '@/tool';
import { WizTableForm } from '@/containers/common'

let { WizPopover } = component_tool

const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })

let componentName = 'practiceRank';

const columns = (record = {}) => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      name: 'practiceId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '日期',
      name: 'date',
      searchItem: {
        disabled: true,
        formatInit: () => record?.practiceDate || ''
      },
    },
    {
      title: '练习名称',
      name: 'name',
      searchItem: {
        disabled: true,
        formatInit: () => record?.practiceName || ''
      },
    },
    {
      title: '排名',
      name: 'rank',
      tableItem: {}
    },
    {
      title: '姓名',
      name: 'fullName',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '账号',
      name: 'userName',
      searchItem: {},
      tableItem: {}
    },
    {
      title: '岗位',
      name: 'positionId',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
        selectType: 'radio',
      },
    },
    {
      title: '组织',
      name: 'orgId',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
        selectType: 'radio',
      }
    },
    {
      title: '账号状态',
      name: 'accountState',
      tableItem: {},
      dict: [
        { code: 1, codeName: "激活" },
        { code: 0, codeName: "禁用" }
      ]
    },
    {
      title: '任职信息',
      name: 'userIdentityInfoList',
      tableItem: {
        width: 200,
        render: (val = [], record) => {
          if (!val.length) { return '暂无任职' }
          let { orgName, positionName } = val[0]
          let _titleView = [`${orgName}-${positionName}`]
          if (val.length > 1) {
            _titleView.push(<span className='manager-person-text-color'> ...</span>)
          }
          return (
            <WizPopover
              content={val.map((e) => <p>{`${e['orgName']}-${e['positionName']}`}</p>)}
              placement="rightTop"
            >
              {_titleView}
            </WizPopover>
          )
        }
      }
    },
    {
      title: '练习次数',
      name: 'count',
      tableItem: {}
    },
    {
      title: '答对总题数',
      name: 'correctAllNum',
      tableItem: {}
    },
    {
      title: '习题总数',
      name: 'questionAllNum',
      tableItem: {}
    },
    {
      title: '最优正确率',
      name: 'maxAccuracy',
      tableItem: {
        render: (text, record) => {
          return text + '%'
        }
      }
    },
    {
      title: '平均正确率',
      name: 'avgAccuracy',
      tableItem: {
        render: (text, record) => {
          return text + '%'
        }
      }
    },
    {
      title: '总答题时长(秒)',
      name: 'allDuration',
      tableItem: {}
    },
    {
      title: '平均练习时长(秒)',
      name: 'avgDuration',
      tableItem: {}
    },
  ]
}

const templateConfig = (data) => {
  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns: columns(data),
        searchBarProps: {
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'export',
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: 'id',
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
      }
    }
  }
}

const apis = (practiceInfo = {}) => {
  let { practiceId, practiceDate } = practiceInfo
  return {
    list: {
      path: `${componentName}/dateList`,
      payload: {
        key: `${componentName}@dateList`,
        apiParams: { practiceId, practiceDate }
      }
    },
    export: {
      path: `${componentName}/dateExport`,
      payload: {
        key: `${componentName}@dateExport`,
        apiParams: { practiceId, practiceDate }
      }
    },
  };

}

let reduxTemplateConfig = (args) => {
  let { practiceInfo } = args
  return {
    apis: apis(practiceInfo),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
